export const helpDeskConstants = {
  HELP_DESK: 'Help Desk',
  WHAT: 'What',
  WHERE: 'Where',
  WHY: 'Why',
  PLACEHOLDER_TEXT:'Please select a field to get information about the fields!'
};
